import tinycolor from 'tinycolor2';

/** @returns {{ hex: string, alpha: number }} alpha 0–100 */
export function parseCssColorParts(value) {
  const raw = value == null || value === '' || value === 'transparent'
    ? '#000000'
    : value;
  const c = tinycolor(raw);
  if (!c.isValid()) return { hex: '#000000', alpha: 100 };
  return {
    hex: c.toHexString(),
    alpha: Math.round(c.getAlpha() * 100),
  };
}

/**
 * @param {string} hex
 * @param {number} alphaPercent 0–100
 * @returns {string|null}
 */
export function toCssColor(hex, alphaPercent = 100) {
  if (!hex) return null;
  const c = tinycolor(hex);
  if (!c.isValid()) return null;
  const alpha = Math.max(0, Math.min(100, Number(alphaPercent))) / 100;
  if (alpha >= 1) return c.toHexString().toLowerCase();
  const { r, g, b } = c.toRgb();
  const a = Math.round(alpha * 1000) / 1000;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}
